<script setup lang="ts">
  import { cva } from 'class-variance-authority';
  import type { VariantProps } from 'class-variance-authority';
  import { computed } from 'vue';

  const props = defineProps<{
    size?: StackedTextVariants['size'];
  }>();

  const stackedTextVariants = cva('', {
    defaultVariants: {
      size: 'default',
    },
    variants: {
      size: {
        default: '[&>:nth-child(1)]:text-base [&>:nth-last-child(1)]:text-xs',
        lg: '[&>:nth-child(1)]:text-xl [&>:nth-child(2)]:text-xs [&>:nth-child(2)]',
        sm: '[&>:nth-child(1)]:text-xs [&>:nth-child(2)]:text-xs',
        xl: '[&>:nth-child(1)]:text-2xl [&>:nth-child(2)]:text-xs [&>:nth-child(2)]',
      },
    },
  });

  type StackedTextVariants = VariantProps<typeof stackedTextVariants>;

  const variant = computed(() => stackedTextVariants({ size: props.size }));
</script>

<template>
  <div class="flex flex-col h-full justify-between gap-y-0.5 overflow-hidden" :class="variant">
    <span class="text-foreground text-ellipsis overflow-hidden">
      <slot name="top" />
    </span>

    <span class="text-muted-foreground text-left">
      <slot name="bottom" />
    </span>
  </div>
</template>

<style scoped></style>
